export const examTabMeta = {
  id: "exam",
  label: "Lịch thi",
  shortLabel: "Thi",
};
